export class FractionUtils {
  public static fractionComparator(valueA: string, valueB: string): number {
    const [numeratorA, denominatorA] = valueA.split('/').map(Number);
    const [numeratorB, denominatorB] = valueB.split('/').map(Number);
    const comparison = numeratorA * denominatorB - numeratorB * denominatorA;
    return comparison === 0 ? 0 : comparison > 0 ? 1 : -1;
  }
}
